import type {Ad, LinearAd, VastAdData} from 'bitmovin-player';

import * as Utils from '../utils/Utils';

export class AdSample {
  private static parseSkipAfter(skipAfter?: number) {
    if (skipAfter === undefined) {
      return undefined;
    }
    if (skipAfter === -1) {
      return skipAfter;
    }
    return Utils.calculateTime(skipAfter);
  }

  wrapperAdsCount?: number;
  adSkipAfter?: number;
  adSkippable?: boolean;
  adClickthroughUrl?: string;
  adDescription?: string;
  adDuration?: number;
  adId?: string;
  adImpressionId?: string;
  adPlaybackHeight?: number;
  adPlaybackWidth?: number;
  adStartupTime?: number;
  adSystem?: string;
  adTitle?: string;
  advertiserName?: string;
  apiFramework?: string;
  audioBitrate?: number;
  clicked = 0;
  clickPosition?: number;
  closed = 0;
  closePosition?: number;
  completed = 0;
  creativeAdId?: string;
  creativeId?: string;
  dealId?: string;
  isLinear?: boolean;
  mediaPath?: string;
  mediaServer?: string;
  mediaUrl?: string;
  midpoint = 0;
  minSuggestedDuration?: number;
  percentageInViewport?: number;
  quartile1 = 0;
  quartile3 = 0;
  skipped = 0;
  skipPosition?: number;
  started = 0;
  streamFormat?: string;
  surveyUrl?: string;
  time?: number;
  timeHovered?: number;
  timeInViewport?: number;
  timePlayed?: number;
  timeUntilHover?: number;
  universalAdIdRegistry?: string;
  universalAdIdValue?: string;
  videoBitrate?: number;
  adPodPosition?: number;
  exitPosition?: number;
  playPercentage?: number;
  skipPercentage?: number;
  clickPercentage?: number;
  closePercentage?: number;
  errorPosition?: number;
  errorPercentage?: number;
  timeToContent?: number;
  timeFromContent?: number;

  constructor(ad?: Ad) {
    if (ad) {
      this.adClickthroughUrl = ad.clickThroughUrl;
      this.adId = ad.id;
      this.mediaUrl = ad.mediaFileUrl;
      if (this.mediaUrl) {
        try {
          const mediaUrl = new URL(this.mediaUrl);
          this.mediaPath = mediaUrl.pathname;
          this.mediaServer = mediaUrl.hostname;
        } catch {
          // Invalid URL, leave fields undefined
        }
      }
      this.isLinear = ad.isLinear;
      this.adPlaybackHeight = ad.height;
      this.adPlaybackWidth = ad.width;

      if (ad.data) {
        this.videoBitrate = ad.data.bitrate === undefined ? undefined : ad.data.bitrate * 1000;
        this.streamFormat = ad.data.mimeType;
        // data.minBitrate
        // data.maxBitrate
      }

      const data = ad.data as VastAdData;
      if (data) {
        if (data.adSystem) {
          this.adSystem = data.adSystem.name;
          // this.adSystemVersion = data.adSystem.version;
        }
        if (data.advertiser) {
          this.advertiserName = data.advertiser.name;
          // this.advertiserId = data.advertiser.id;
        }
        // data.codec
        // data.delivery
        // data.pricing
        this.apiFramework = data.apiFramework;

        if (data.creative) {
          this.creativeAdId = data.creative.adId;
          this.creativeId = data.creative.id;

          if (data.creative.universalAdId) {
            this.universalAdIdRegistry = data.creative.universalAdId.idRegistry;
            this.universalAdIdValue = data.creative.universalAdId.value;
          }
        }
        this.adDescription = data.adDescription;
        this.minSuggestedDuration = Utils.calculateTimeWithUndefined(data.minSuggestedDuration);
        if (data.survey) {
          this.surveyUrl = data.survey.uri;
          // data.survey.type;
        }
        this.adTitle = data.adTitle;
        this.wrapperAdsCount = data.wrapperAdIds ? data.wrapperAdIds.length : 0;
      }
    }
    const linearAd = ad as LinearAd;
    if (linearAd) {
      this.adSkipAfter = AdSample.parseSkipAfter(linearAd.skippableAfter);
      this.adSkippable = linearAd.skippable || (this.adSkipAfter === undefined ? undefined : this.adSkipAfter >= 0);
      this.adDuration = Utils.calculateTime(linearAd.duration);
    }
  }
}
